import * as React from 'react';
import { useUpdateEffect } from 'react-use';
import { Editor, Transforms } from 'slate';
import { useSlate } from 'slate-react';

import { getNodes } from '../../../../../slatePlugins/common/queries/getNodes';
import { ELEMENT_HYPER_LINK } from '../defaults';
import { insertLink } from '../transform/insertLinkAtSelection';
import { HyperLinkPopover, HyperLinkPopoverProps } from './HyperLinkPopover';

export interface HyperLinkPopoverOnCollapsedProps extends HyperLinkPopoverProps {}

export const HyperLinkPopoverOnCollapsed = (props: HyperLinkPopoverOnCollapsedProps) => {
  const { children, onApplyLink, onPopoverClose, ...rest } = props;
  const editor = useSlate();
  const editorSelection = React.useRef(null);

  useUpdateEffect(() => {
    if (editor.selection) {
      editorSelection.current = editor.selection;
    }
  }, [editor.selection]);

  const handlePopoverClose = React.useCallback(() => {
    Transforms.select(editor, editorSelection.current);
    onPopoverClose?.();
  }, [editor, onPopoverClose]);

  const handleApplyLink = React.useCallback(
    async (url, linkSettings, linkAction) => {
      // Set current pointer
      editor.selection = editorSelection.current;
      const [item] = Array.from(
        getNodes(editor, {
          match: { type: ELEMENT_HYPER_LINK } as any,
        }),
        ([node, range]) => ({
          node,
          range,
        })
      );

      // Set hyperlink block range
      editor.selection = Editor.range(editor, item?.range);

      insertLink(editor, {
        url,
        linkSettings,
        linkAction,
      });
      onApplyLink?.(url, linkSettings, linkAction);
      Transforms.collapse(editor, { edge: 'end' });
    },
    [editor, onApplyLink]
  );

  return (
    <HyperLinkPopover onApplyLink={handleApplyLink} onPopoverClose={handlePopoverClose} {...rest}>
      {children}
    </HyperLinkPopover>
  );
};
